module.exports = __webpack_public_path__ + "static/media/ic-minus.0ea06bab.svg";